import { AtLinkButton, AtLinkButtonProps } from '../../atoms'
import { getAtImageVariant } from '../../atoms/at-image/at-image.props'
import { Media, OrMedia } from '../../organisms'
import { cn } from '../../utils/cn'

type MlBannerHeadingCtaAlignment = 'left' | 'center'

export interface MlBannerHeadingCtaProps {
  name?: string
  headline?: string
  description?: string
  media?: Media
  cta?: AtLinkButtonProps
  alignment?: MlBannerHeadingCtaAlignment
}

export const MlBannerHeadingCta = ({
  media,
  headline,
  description,
  cta,
  alignment = 'left',
}: MlBannerHeadingCtaProps) => {
  const hasMedia = Boolean(media && media.src)
  const hasLink = Boolean(cta && cta.title && cta.actionTarget && cta.target)
  if (!hasMedia && !hasLink) return null
  return (
    <div className="flex relative flex-col items-center justify-center">
      {media && <OrMedia {...media} className={getAtImageVariant('background')} />}
      <div className="absolute inset-0 bg-neutrals-black/[.56]"></div>
      <div
        className={cn(
          'flex flex-col justify-center align-center w-full space-y-6 slg:space-y-10 z-10 p-8 slg:px-12 slg:py-17 lg:px-41.5 lg:py-17',
          alignment === 'center' && 'items-center text-center',
          alignment === 'left' && 'items-left text-left'
        )}
      >
        <div className="space-y-4 slg:space-y-6 text-neutrals-white text-shadow shadow-light-on-dark slg:p-2.5 pr-6 sm:pr-0">
          {headline && (
            <h2 className="font-heading font-medium text-32 leading-9 slg:text-40 slg:leading-12">{headline}</h2>
          )}
          {description && <p className="leading-6 slg:text-20 slg:leading-7.5">{description}</p>}
        </div>
        {hasLink && (
          <AtLinkButton
            className="min-[430px]:w-fit"
            variant="button-primary-dark"
            title={cta?.title}
            actionTarget={cta?.actionTarget}
            target={cta?.target}
            parentName="MlBannerHeadingCta"
          />
        )}
      </div>
    </div>
  )
}
